import React from 'react';
import { Checkbox } from 'semantic-ui-react';
import { isChecked } from '@/utils/resultsHelper';

const FormBooleanDescription = ({
  canEdit,
  field,
  onChange,
  text,
}) => (
  <Checkbox
    checked={isChecked(text)}
    className="aridhia-form-boolean-description"
    disabled={!canEdit}
    label={field.label}
    onClick={canEdit ? () => onChange(!isChecked(text)) : undefined}
    toggle
  />
);

export default FormBooleanDescription;
